module.exports = __webpack_public_path__ + "img/close.7be246d4.svg";